import { bindable } from 'aurelia-framework';

import { BaseViewModel } from '~/base-view-model';

export class TabbedPanel extends BaseViewModel {
	private static tabCount = 0;

	@bindable private readonly label: string;

	@bindable private id?: string;

	@bindable public selected?: boolean;

	@bindable public disabled?: boolean;

	private panelId?: string;

	tabId?: string;

	public attached() {
		// Auto-generate a unique ID if none given,
		// this is used to tie a tab panel to a tab button with
		// "aria-labelledby"
		if (!this.id) {
			this.id = 'tabbed-panel-' + TabbedPanel.tabCount;
			TabbedPanel.tabCount++;
		}
		this.panelId = this.id + '-panel';
		this.tabId = this.id + '-tab';
	}
}
